export const LOCAL_STORAGE_KEY = {
  profile: 'profile',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  userRoutes: 'userRoutes',
  classList: 'classList',
  currentBranch: 'currentBranch',
  currentBranchName: 'currentBranchName',
  authToken: 'authToken',
  ticketColumns: 'ticketColumns',
  kibanaInfoLogsEnabled: 'kibanaInfoLogsEnabled',
};
